import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "mediaTypeRadio", "customLinkSection", "hybridSection", "placeSection", "zoomSection", "specificDateSection", "recurrentSection", "dateRangeCheckbox", "dateRangeSection"]

  updateMediaType() {
    const selected = this.element.querySelector("input[name*='media_type']:checked")?.value
    if (!selected) return

    this.toggleSection(this.customLinkSectionTarget, selected === "custom")
    this.toggleSection(this.hybridSectionTarget, selected !== "inperson")

    if (this.hasPlaceSectionTarget) {
      this.toggleSection(this.placeSectionTarget, selected === "inperson")
    }
    if (this.hasZoomSectionTarget) {
      this.toggleSection(this.zoomSectionTarget, selected === "zoom")
    }
  }

  updateHybrid() {
    if (!this.hasPlaceSectionTarget) return
    const hybrid = this.element.querySelector("input[name*='hybrid']:checked")?.value === "true"
    const mediaType = this.element.querySelector("input[name*='media_type']:checked")?.value
    this.toggleSection(this.placeSectionTarget, mediaType === "inperson" || hybrid)
  }

  // Replica SettingsWhen.tsx: alterna entre fecha especifica y fecha recurrente.
  // Deshabilita los inputs de la seccion oculta para evitar que el name
  // `[starts_at]` (compartido entre fecha especifica y rango recurrente) se
  // envie duplicado.
  toggleRecurrent(event) {
    const recurrent = event.target.value === "true"
    this.toggleSection(this.specificDateSectionTarget, !recurrent)
    this.toggleSection(this.recurrentSectionTarget, recurrent)

    this.specificDateSectionTarget.querySelectorAll("input").forEach(i => i.disabled = recurrent)
    if (this.hasDateRangeSectionTarget) {
      const rangeEnabled = this.dateRangeCheckboxTarget.checked
      this.dateRangeSectionTarget.querySelectorAll("input").forEach(i => i.disabled = !recurrent || !rangeEnabled)
    }
  }

  toggleDateRange() {
    const checked = this.dateRangeCheckboxTarget.checked
    this.toggleSection(this.dateRangeSectionTarget, checked)
    this.dateRangeSectionTarget.querySelectorAll("input").forEach(i => i.disabled = !checked)
  }

  toggleSection(target, show) {
    if (show) {
      target.classList.remove("hidden")
    } else {
      target.classList.add("hidden")
    }
  }
}
